export default class ObservationLegal {
  id!: number
  user!: number
  date_registered!: Date
  observation!: string
  legal!: number
}
